import logger from '@utils/logger';
import { IFile } from '@typescript/index';
const groupArrayByLabel = data => data.reduce((result, item) => {
  const key = item.category;
  if (!result[key]) {
    result[key] = [];
  }
  result[key].push(item);
  return result;
}, {});
const getFileListData = async (url: string, getProductFiles = false): Promise<void | [string, IFile[]][]> => {
  const fileList = fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      collections: ['Kerrafront', 'Kerradeco', 'Rigio', 'Rega', 'Solvo', 'Querra', 'Querra WR', 'Linerio', 'Soform', 'Slot', 'Vifront', 'Solid', 'Max-3', 'Infratop', 'Fronto', 'Systemy sufitowe KCS', 'Fronto Max'],
      getProductFiles
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json();
  }).then(data => Object.entries(groupArrayByLabel(data))).catch(error => {
    logger.error('There was a problem with the fetch operation:', error);
  });
  return fileList as Promise<void | [string, IFile[]][]>;
};
export default getFileListData;